module.exports = __webpack_public_path__ + "img/scop8.f2e36494.jpg";